/** Without case or accents, so "joao" finds "João". */
function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}

/**
 * Quick filter for lists already on screen (roster, giveaway entries,
 * streamers): true when `query` is empty or any of the values contains it.
 */
export function matchesQuery(query: string, ...values: (string | null | undefined)[]): boolean {
  const wanted = fold(query.trim());
  if (wanted === '') return true;
  return values.some((v) => v != null && fold(v).includes(wanted));
}
